import type { ListboxOption } from '@/components/ui/listbox';

export interface GivingLinkFundOptionSource {
  id: string;
  name: string;
  fundType: string;
  customTypeName?: string | null;
  defaultCurrency: string;
  isActive?: boolean;
}

/** Fund picker options. Currency lives on the description line, not in the title. */
export const toGivingLinkFundOptions = (
  funds: GivingLinkFundOptionSource[],
  format: {
    description: (fund: GivingLinkFundOptionSource) => string;
    inactiveSuffix?: string;
  },
): ListboxOption[] =>
  funds.map((fund) => ({
    value: fund.id,
    label:
      fund.isActive === false && format.inactiveSuffix
        ? `${fund.name} (${format.inactiveSuffix})`
        : fund.name,
    description: format.description(fund),
    keywords: [fund.defaultCurrency, fund.name],
  }));
